// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"310":"c5df329a","392":"c5df329a"}[chunkId] + ".chunk.css";
};